// The words a question or an initiative rests on (contract v8, kanban
// 9eb5f005): one blockquote per excerpt, who said it and where, and an "Open
// source" link that lands the reader on the quote in the meeting transcript
// or the email. Shared by the Merlin's-questions cards, the initiative pop-up
// and the portal's My roadmap, so a quote reads the same everywhere.
//
// 2026-09-28 check-in: "Nobody holds an action on sampling JTM" named two
// meetings and no text; Ravi: "if I click enough buttons, I can get to
// connecting the dots." The acceptance is the opposite: read the supporting
// quote without leaving the page.

import type { InitiativeEvidence, SourceRef } from '../../services/roadmapReports';
import { evidenceAttribution, evidenceSourceRef } from './evidenceUtils';
import styles from './RoadmapV2.module.css';

export type OpenSourceFn = (ref: SourceRef) => void;

interface Props {
  evidence: readonly InitiativeEvidence[];
  /** Opens the source viewer; omitted (the portal page) → sources are named, not linked. */
  onOpenSource?: OpenSourceFn;
  /** What to say when there is nothing to quote; null renders nothing. */
  emptyNote?: string | null;
  'aria-label'?: string;
}

export function EvidenceList({ evidence, onOpenSource, emptyNote = null, 'aria-label': ariaLabel = 'Evidence' }: Props) {
  if (evidence.length === 0) {
    return emptyNote ? <div className={`${styles.muted} ${styles.evidenceEmpty}`} data-testid="evidence-empty">{emptyNote}</div> : null;
  }
  return (
    <ul className={styles.evidenceList} aria-label={ariaLabel}>
      {evidence.map((ev, idx) => {
        const ref = evidenceSourceRef(ev);
        return (
          <li key={`${ev.source_kind}:${ev.source_id}:${idx}`} className={styles.evidenceItem}>
            <blockquote className={styles.evidenceQuote}>{ev.quote}</blockquote>
            <div className={styles.evidenceWho}>
              <span>{evidenceAttribution(ev)}</span>
              {ref && onOpenSource && (
                <button
                  type="button"
                  className={styles.evidenceOpen}
                  onClick={() => onOpenSource(ref)}
                  title="Open the source at this quote"
                >
                  Open source
                </button>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
